class DismissModal {
    constructor(modalID) {
        this.modalID = modalID;
    }
    enable(notForDismissModal = false){
        let modal = document.getElementById(this.modalID)
        let boostrapModal = bootstrap.Modal.getOrCreateInstance(modal);
        boostrapModal._config.backdrop = true;
        boostrapModal._config.keyboard = true;

        let dismissModalElements;
        if(notForDismissModal){
            dismissModalElements = modal.querySelectorAll('[data-bs-dismiss=false]:not(.not-for-dismiss-modal)');
        } else {
            dismissModalElements = modal.querySelectorAll('[data-bs-dismiss=false]');
        }
        dismissModalElements.forEach(el => {
            el.setAttribute('data-bs-dismiss', 'modal');
        });
    }
    disable(notForDismissModal = false){
        let modal = document.getElementById(this.modalID)
        let boostrapModal = bootstrap.Modal.getOrCreateInstance(modal);
        boostrapModal._config.backdrop = 'static';
        boostrapModal._config.keyboard = false;

        let dismissModalElements;
        if(notForDismissModal){
            dismissModalElements = modal.querySelectorAll('[data-bs-dismiss=modal]:not(.not-for-dismiss-modal)');
        } else {
            dismissModalElements = modal.querySelectorAll('[data-bs-dismiss=modal]');
        }
        dismissModalElements.forEach(el => {
            el.setAttribute('data-bs-dismiss', 'false');
        });
    }
}
window.DismissModal = DismissModal;

// Prevent button focus on Modal hide
KTUtil.onDOMContentLoaded(function () {
    $('.modal').on('show.bs.modal', function (event) {
        const button = $(event.relatedTarget); // Button that triggered the modal
        button.one('focus', function (event) {
            $(this).blur();
        });
    });
});